// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3315":"036da0cf","7387":"036da0cf","7853":"036da0cf","8317":"036da0cf"}[chunkId] + ".chunk.css";
};